var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"variables-explanation"},[_c('separator'),_vm._v(" "),_c('div',{staticClass:"explain-variables-button",on:{"click":_vm.openVariablesExplanation}},[_vm._v("\n    למה זה הכסף שנשאר לי להוציא?\n  ")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec2f8bdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/VariablesExplanation.vue
// module id = null
// module chunks = 